import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

export type SPBenefitTokenBatchLocs =
	| 'SPBenefitTokenBatchTitleInstructions'
	| 'SPBenefitTokenBatchLabelBatchId'
	| 'SPBenefitTokenBatchButtonInvalidateBatch';

export const spBenefitTokenBatchLocs: LocDefs<SPBenefitTokenBatchLocs> = {
	SPBenefitTokenBatchTitleInstructions: {
		defaultValue: 'Individual Tokens by Batch',
		description: 'Title for the benefit token batch section',
		displayPath: 'Catalogs|BenefitTokens|Title|BatchTokenInstructions',
		displayType: 'Title',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Title.BatchTokenInstructions',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenBatchLabelBatchId: {
		defaultValue: 'Batch ID',
		description: 'Label for the batch ID field in token batch form',
		displayPath: 'Catalogs|BenefitTokens|Field Label|BatchID',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.FieldLabel.BatchID',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenBatchButtonInvalidateBatch: {
		defaultValue: 'Invalidate Batch Tokens',
		description: 'Button to invalidate tokens for a specific batch',
		displayPath: 'Catalogs|BenefitTokens|Button|InvalidateBatch',
		displayType: 'Button',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Button.InvalidateBatch',
		portal: 'SP' as LocPortal,
	},
};

export const LOC_KEYS = MapLocKeys<SPBenefitTokenBatchLocs>(spBenefitTokenBatchLocs);
export type SpBenefitTokenBatchLocKeys = LocMap<SPBenefitTokenBatchLocs>;
